import { withHandlers, withProps, withStateHandlers } from 'recompose'
import { compose } from 'redux'
import AppointmentItem from './AppointmentItem'
import {
  formatAppointmentDate,
  isNicknameDuplicate,
  isNicknamePersonalized,
  withNicknameSufix
} from 'components/MyGarage2.0/helpers'
import { connect } from 'react-redux'
import { showUpdateCancelInstructionsModal } from 'components/MyAppointments/BOTMyAppointmentsDetails/components/UpdateCancelInstructionsModal/actions.js'
import { composeFormattedPhoneNumberFromObject } from 'helpers/phone-number'
import { getGoogleMapsDirections } from 'components/MyAppointments/BOTMyAppointmentsDetails/components/AppointmentDetails/helpers'
import { GENERIC_TRAILER_TYPE, TRAILER_TYPE } from 'components/MyGarage2.0/constants'

const withNextAppointmentHandlers = withHandlers({
  showUpdateCancelInstructionsModalHandler: ({
    showUpdateCancelInstructionsModal,
    updateCancelAppointment
  }) => (e) => {
    e.preventDefault()
    showUpdateCancelInstructionsModal(updateCancelAppointment)
  }
})

const withViewDetailsStateHandler = withStateHandlers({
  isDetailsAreExpanded: false
}, {
  toggleAppointmentDetails: ({ isDetailsAreExpanded }) => () => ({ isDetailsAreExpanded: !isDetailsAreExpanded })
})

const withNextAppointmentProps = withProps(({
  nextAppointment: {
    timeSlot,
    storeAddress: {
      phoneNumber,
      latitude,
      longitude,
      address1,
      city,
      zipcode
    }
  },
  userVehicle: {
    masterVehicle: {
      modelDesc,
      makeDesc,
      yearDesc,
      subModelDesc
    },
    vehicleNickname,
    vehicleName,
    vehicleType
  }
}) => ({
  appointmentDate: formatAppointmentDate(timeSlot),
  formattedVehicleNickName: isNicknamePersonalized(vehicleName, vehicleNickname) ?
    vehicleNickname :
    isNicknameDuplicate(vehicleNickname) ? withNicknameSufix(vehicleNickname) : `${yearDesc} ${makeDesc}`,
  formattedVehicleYMME: isNicknamePersonalized(vehicleName, vehicleNickname) ? vehicleName : `${modelDesc} ${subModelDesc}`,
  locationPhoneNumberFormatted: composeFormattedPhoneNumberFromObject(phoneNumber),
  googleMapsDirections: getGoogleMapsDirections({ latitude, longitude, address1, city, zipcode }),
  isGenericTrailer: vehicleType === GENERIC_TRAILER_TYPE,
  isTrailer: vehicleType === TRAILER_TYPE
}))

export default compose(
  connect(null, { showUpdateCancelInstructionsModal }),
  withNextAppointmentHandlers,
  withNextAppointmentProps,
  withViewDetailsStateHandler
)(AppointmentItem)
